document.addEventListener('DOMContentLoaded', async () => {
  const form = document.querySelector('.collection-search__form');
  const input = document.querySelector('.collection-search__input');
  const productGridContainer = document.querySelector('#ProductGridContainer');

  if (!form || !input || !productGridContainer) return;

  const params = new URLSearchParams(window.location.search);
  const searchTerm = (params.get('q') || '').trim();

  if (!searchTerm) return;

  input.value = searchTerm;

  const collectionPath = window.location.pathname.replace(/\/$/, '');
  const sortBy = params.get('sort_by');

  productGridContainer.innerHTML =
    '<div class="page-width"><p>Searching all collection pages...</p></div>';

  try {
    const allItems = [];
    const seenHandles = new Set();
    const BATCH_SIZE = 4;
    let page = 1;
    let finished = false;

    // Fetch every collection page until no more products are returned.
    while (!finished) {
      const pages = Array.from(
        { length: BATCH_SIZE },
        (_, i) => page + i
      );

      const results = await Promise.all(
        pages.map(async (pageNumber) => {
          const url = new URL(
            collectionPath,
            window.location.origin
          );

          url.searchParams.set(
            'section_id',
            'main-collection-product-grid'
          );
          url.searchParams.set('page', pageNumber);

          if (sortBy) {
            url.searchParams.set('sort_by', sortBy);
          }

          const response = await fetch(url.toString());

          if (!response.ok) {
            throw new Error(
              `Could not load collection page ${pageNumber}.`
            );
          }

          const html = await response.text();
          const parsed = new DOMParser().parseFromString(
            html,
            'text/html'
          );

          const grid = parsed.querySelector('#product-grid');

          return {
            pageNumber,
            items: grid
              ? Array.from(
                  grid.querySelectorAll(':scope > .grid__item')
                )
              : []
          };
        })
      );

      results.sort((a, b) => a.pageNumber - b.pageNumber);

      for (const result of results) {
        if (result.items.length === 0) {
          finished = true;
          break;
        }

        for (const item of result.items) {
          const link = item.querySelector('a[href*="/products/"]');

          if (!link) continue;

          const handle = getProductHandle(link.href);

          if (!handle || seenHandles.has(handle)) continue;

          seenHandles.add(handle);
          allItems.push(item);
        }
      }

      page += BATCH_SIZE;

      // Safety limit: prevents an endless request loop.
      if (page > 200) {
        throw new Error(
          'Search stopped at the safety limit of 200 pages.'
        );
      }
    }

    console.log('Collection product cards loaded:', allItems.length);

    // Search the text available on each rendered product card.
    const term = searchTerm.toLocaleLowerCase().trim();

const matchingItems = allItems.filter((item) => {
  const text = item.textContent.toLocaleLowerCase();

  if (text.includes(term)) return true;

  // Handle simple singular/plural variations.
  if (term.endsWith('s') && term.length > 1) {
    return text.includes(term.slice(0, -1));
  }

  return text.includes(`${term}s`);
});

    console.log('Matching product cards:', matchingItems.length);

    // Load Dawn's collection grid structure.
    const firstPageUrl = new URL(
      collectionPath,
      window.location.origin
    );

    firstPageUrl.searchParams.set(
      'section_id',
      'main-collection-product-grid'
    );
    firstPageUrl.searchParams.set('page', '1');

    if (sortBy) {
      firstPageUrl.searchParams.set('sort_by', sortBy);
    }

    const firstResponse = await fetch(firstPageUrl.toString());

    if (!firstResponse.ok) {
      throw new Error('Could not load the collection grid.');
    }

    const firstHtml = await firstResponse.text();
    const firstDocument = new DOMParser().parseFromString(
      firstHtml,
      'text/html'
    );

    const dawnGrid = firstDocument.querySelector(
      '#ProductGridContainer'
    );

    const productGrid = dawnGrid?.querySelector('#product-grid');

    if (!dawnGrid || !productGrid) {
      throw new Error('Dawn product grid was not found.');
    }

    productGrid.innerHTML = '';

    if (matchingItems.length === 0) {
      showNoResults(productGridContainer, searchTerm);
      return;
    }

    matchingItems.forEach((item) => {
      productGrid.appendChild(item);
    });

    // Remove normal collection pagination.
    dawnGrid.querySelector('.pagination')?.remove();

    // Show the number of matching results.
    const heading = document.createElement('div');

    heading.className =
      'collection-search-results-heading page-width';

    heading.innerHTML = `
      <h2>Search results</h2>
      <p>
        ${matchingItems.length}
        result${matchingItems.length === 1 ? '' : 's'}
        for <strong>"${escapeHtml(searchTerm)}"</strong>
      </p>
    `;

    productGridContainer.replaceChildren(heading, dawnGrid);

  } catch (error) {
    console.error('Collection search error:', error);

    productGridContainer.innerHTML = `
      <div class="collection-search-message page-width">
        <h2>Search could not be completed</h2>
        <p>
          ${escapeHtml(error.message)}
          Please try again or contact the store owner.
        </p>
      </div>
    `;
  }
});

function getProductHandle(url) {
  try {
    const pathname = new URL(url).pathname;
    const match = pathname.match(/\/products\/([^/]+)/);
    return match ? match[1] : null;
  } catch {
    return null;
  }
}

function showNoResults(container, searchTerm) {
  container.innerHTML = `
    <div class="collection-search-message page-width">
      <h2>No results found</h2>
      <p>
        We couldn't find anything matching
        <strong>"${escapeHtml(searchTerm)}"</strong>
        in this collection.
      </p>
      <a href="${escapeHtml(window.location.pathname)}" class="button">
        Clear search
      </a>
    </div>
  `;
}

function escapeHtml(value) {
  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
}